import { AutoMap } from "@automapper/classes";
import { AreaMapDTO } from "./area-map.dto";
import { MPCADTO } from "./mpca.dto";
import { ZoneMeasureDTO } from "./zone-measure.dto";

export class ZoneDTO {
    @AutoMap()
    code!: string;
    @AutoMap()
    position!: number;
    @AutoMap()
    description?: string;
    @AutoMap()
    customerReference?: string;
    @AutoMap()
    type!: number;
    @AutoMap()
    usage!: number;
    @AutoMap()
    buildingType!: number;
    @AutoMap()
    buildingTypeNonStandard?: string;
    @AutoMap()
    roomUsage!: number;
    @AutoMap()
    roomUsageNonStandard?: string;
    @AutoMap()
    onSiteProtectionAndSealingType?: string;
    @AutoMap()
    activitySimulation?: number;
    @AutoMap()
    observation?: string;
    @AutoMap()
    isDepose!: boolean;

    @AutoMap(() => [MPCADTO])
    mpcaList: MPCADTO[] = [];

    @AutoMap(() => [ZoneMeasureDTO])
    zoneMesureList: ZoneMeasureDTO[] = [];

    @AutoMap(() => [AreaMapDTO])
    areaMapList: AreaMapDTO[] = [];
}
